import React, {useState} from 'react';
import {ScrollView, View} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {get, noop} from 'lodash';

import Button from '/component/base/Button/Button';
import Checkbox from '/component/base/Checkbox/Checkbox';
import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {
  generateOnCheckboxChange,
  getFormattedString,
} from '../ClientJourneyTask.util';
import {TASK_TYPE} from '../clientJourneyTaskComponentMap';

import {styles} from './TaskDetails.style';
interface TaskDetailsProps {
  taskItem: {
    id: number;
    label: string;
    [key: string]: any;
  };
  taskChecked: boolean;
  onTaskStatusChange: (checked: boolean, id: number, label?: string) => void;
  currentCheckInDate: Date | string;
  lastCheckInDate: string;
  weeklyCheckInsTasks: any[];
  lastPaidRank: string;
}

export const TaskDetails: React.FC<TaskDetailsProps> = ({
  taskItem = {},
  taskChecked = false,
  onTaskStatusChange = noop,
  currentCheckInDate = null,
  lastCheckInDate = [],
  weeklyCheckInsTasks = null,
  lastPaidRank = null,
}) => {
  const {tt, ts} = useTranslation('screen.firstWeek.taskDetails');

  const navigation = useNavigation();
  const [isChecked, setIsChecked] = useState(taskChecked);

  const chckboxIconName = isChecked
    ? 'checkbox-selected'
    : 'checkbox-unselected';
  const checkboxStyle = isChecked ? styles.selectedIcon : styles.unSelectedIcon;

  const checkboxTextStyle = isChecked
    ? {...styles.taskDetailTitleText, ...styles.strikeThroughText}
    : styles.taskDetailTitleText;

  const onChange = (e: any, id: any, label: any) => {
    setIsChecked(!isChecked);
    onTaskStatusChange(e, id);
    generateOnCheckboxChange({
      checkboxName: label,
      currentScreenName: 'task_details',
      checkedStatus: e,
      lastPaidRank: lastPaidRank,
    });
  };

  const onPress = (e: any, id: any, label: any) => {
    generateOnCheckboxChange({
      checkboxName: label,
      currentScreenName: 'task_details',
      checkedStatus: e,
      lastPaidRank: lastPaidRank,
    });
    setIsChecked(true);
    onTaskStatusChange(
      true,
      get(taskItem, 'id', ''),
      get(taskItem, 'label', ''),
    );
    navigation.goBack();
  };

  // @ts-expect-error TS(7030): Not all code paths return a value.
  const renderTaskDetails = () => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const Component = TASK_TYPE[get(taskItem, 'label', '')];
    if (Component) {
      return (
        <Component
          {...(Component === TASK_TYPE['Weekly check-in']
            ? {
                weeklyCheckInsTasks: weeklyCheckInsTasks,
                currentCheckInDate: currentCheckInDate,
                lastCheckInDate: lastCheckInDate,
                taskStatus: isChecked,
                lastPaidRank: lastPaidRank,
              }
            : {
                label: getFormattedString(get(taskItem, 'label', '')),
                lastPaidRank: lastPaidRank,
              })}
        />
      );
    }
  };

  const isOptaviaLabel = get(taskItem, 'label', '').includes(
    'Share the OPTAVIA App',
  );
  return (
    <ScrollView contentContainerStyle={styles.base}>
      <View style={styles.container}>
        <View style={styles.taskTitleContainer}>
          <View style={styles.iconContainer}>
            <Checkbox
              checkedIconName={chckboxIconName}
              style={{icon: checkboxStyle}}
              rectangleCheckbox
              checked={isChecked}
              onChange={(e: any) =>
                onChange(e, get(taskItem, 'id', ''), get(taskItem, 'label', ''))
              }
            />
          </View>
          <Text
            variant="button"
            style={checkboxTextStyle}
            {...testProperties(DownlineProfile.cjTaskDetailName)}>
            {isOptaviaLabel ? (
              <Text
                style={styles.optaText}
                variant="button"
                {...testProperties(DownlineProfile.cjtaskItemLabel)}>
                Share the OPTA
                <Text variant="button" style={styles.optaTextLabel}>
                  {'VIA '}
                </Text>
                App
              </Text>
            ) : (
              tt('name', get(taskItem, 'label', ''))
            )}
          </Text>
        </View>
        <View>{renderTaskDetails()}</View>
      </View>
      {!isChecked && (
        <View style={styles.buttonContainer}>
          <View style={styles.bottomButton}>
            <Button
              type="primary"
              style={{base: styles.button, text: {fontWeight: 'bold'}}}
              onPress={(e: any) =>
                onPress(e, get(taskItem, 'id', ''), get(taskItem, 'label', ''))
              }
              {...testProperties(
                DownlineProfile.cjTaskDetailMarskTaskCompleteButton,
              )}>
              {ts('taskComplete', 'Mark task complete')}
            </Button>
          </View>
        </View>
      )}
    </ScrollView>
  );
};
